var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',{staticClass:"button-spinner",class:{ 'button-spinner--secondary': _vm.secondary, 'button-spinner--primary': !_vm.secondary }})
}
var staticRenderFns = []

export { render, staticRenderFns }